import api from '../token';

export const AddProcessoInventario = async (dados) => {
  try {
    const response = await api.post('/Inventario', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
